import styled from 'styled-components';
import { H6 } from 'components/Text';
import { palette } from '@m12s/component-library';
import { DefaultCardBorder } from 'components/MachineHeader/styled';

export const CardContainer = styled.div`
  display: grid;
  grid-template-rows: auto 1fr auto;
  ${DefaultCardBorder}
  background: ${palette.White};
  flex: 1;
  height: 100%;
`;

export const CardHead = styled.div`
  margin: 0 1.5rem;
  padding: 1.5rem 0;
  font-weight: 600;
  color: ${palette.Indigo600};
  border-bottom: 1px solid ${palette.Grey300};
`;

export const CardHeader = styled(H6)`
  color: ${palette.Indigo600};
  font-weight: 600;
`;

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  gap: 0.8rem;
`;

export const CardFoot = styled.div`
  padding: 1rem 1.5rem;
  border-top: 1px solid ${palette.Grey300};
`;

export const CardBodyRow = styled.div`
  display: grid;
  grid-template-columns: ${({ columns = 1 }) => {
    return `repeat(${columns}, 1fr)`;
  }};
  gap: 1rem;
`;

export const DescriptionRow = styled.div`
  margin-top: 2rem;
`;

export const LargeText = styled.span`
  color: ${palette.Grey700};
  font-size: 2rem;
  line-height: 2rem;
  font-style: normal;
  font-weight: 600;
`;

export const MediumHeaderText = styled.span`
  color: ${palette.Grey700};
  font-size: 0.9rem;
  line-height: 1rem;
  font-style: normal;
  font-weight: 600;
`;

export const MediumText = styled.span`
  color: ${palette.Grey700};
  font-size: 0.9rem;
  font-style: normal;
  font-weight: 400;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const SelectActivityTableContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  height: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const SelectActivityItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow-y: auto;
`;

export const SelectActivityItem = styled.div`
  display: grid;
  grid-template-columns: 1fr minmax(8rem, 0.2fr) 3rem;
  ${DefaultCardBorder}
`;
